/**
 * Numeric breakpoint matched to `breakpoints.smallLaptop` (992px in CSS but
 * the v1.7 sections were built against a 769px design boundary). Treat this
 * as the SINGLE source of truth for JS-driven mobile detection so we don't
 * recreate a "769 vs 992 dead zone" inside React components.
 *
 * If you need a CSS media query, use `breakpoints.smallLaptop` instead — the
 * two values intentionally differ (CSS = layout breakpoint, JS = behavior
 * breakpoint such as `width="100%"` on CTA buttons).
 */
export const MOBILE_BREAKPOINT_PX = 769;

const theme = {
  colors: {
    primary: '#1291FF',
    white: '#fff',
    mystic: '#E2EBEB',
    mountainMeadow: '#11CC88',
    outerSpace: '#243636',
    nebula: '#CCDBDB',
    grannySmith: '#889E9E',
    nevada: '#5D7575',
    limedSpruce: '#3B5252',
    geyser: '#CFDDDD',
    rainForest: '#007060',
    sunsetOrange: '#FF5252',
  },
  maxWidth: '1000px',
  maxWidthText: '720px',
  breakpoints: {
    phone: '600px',
    tablet: '768px',
    smallLaptop: '992px',
    desktop: '1200px',
    largeDesktop: '1440px',
  },
  mobileBreakpointPx: MOBILE_BREAKPOINT_PX,
};

export default theme;
